import { colors } from '@/theme/colors';
import { ApexOptions } from 'apexcharts';
import * as React from 'react';
import { useEffect, useState } from 'react';
// eslint-disable-next-line import/default
import Chart from 'react-apexcharts';

import { useWindowDimensions } from '@/hooks/useWindowDimensions';

import { JointCouplingSeriesData } from '@/models/reportV2.model';

type JointCouplingGraphProps = {
  data: JointCouplingSeriesData[];
  side: string;
  xMin: number;
  xMax: number;
  xRange: number;
};

export const WalkJointCouplingGraph = ({ data, side, xMin, xMax, xRange }: JointCouplingGraphProps) => {
  const { width, height } = useWindowDimensions();
  const [windowSize, setWindowSize] = useState('small');

  useEffect(() => {
    if (height != null) {
      if (height > 860) {
        setWindowSize('large');
      } else {
        setWindowSize('small');
      }
    }
    console.log(data.length - 1);
  }, [width]);
  const markerLabels = ['HO', 'TO', 'MSw', 'TSw', 'IC', 'MSt'];
  // create marker array so that only the scatter has markers
  const markerSizes = [];
  const markerColors = [];
  for (const value of Object.values(data)) {
    const Value = value as unknown as any;
    const type = Value.type;
    if (type === 'scatter') {
      markerSizes.push(3);
      markerColors.push('#E81A1A');
    } else {
      markerSizes.push(0);
      markerColors.push('#E81A1A');
    }
  }

  const options: ApexOptions = {
    chart: {
      type: 'line',
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      offsetX: -10,
    },
    dataLabels: {
      enabled: true,
      enabledOnSeries: [data.length - 2],
      formatter: function (val: number, { seriesIndex, dataPointIndex, w }) {
        return markerLabels[dataPointIndex];
      },
      textAnchor: 'middle',
      offsetY: -5,
      background: {
        enabled: false,
      },
      style: {
        fontSize: '8px',
        fontFamily: 'Montserrat',
        colors: ['#707070'],
      },
    },
    xaxis: {
      min: xMin,
      max: xMax,
      tickAmount: xRange,
      labels: {
        formatter: function (value: string) {
          const Value = value as unknown as number;
          return Value.toFixed(0);
        },
        show: true,
        style: {
          fontSize: '8px',
        },
        offsetY: -5,
      },
      title: {
        text: 'Hip Angle (deg)',
        style: {
          fontSize: '8px',
        },
      },
    },
    yaxis: {
      labels: {
        formatter: function (value: number) {
          return value.toFixed(0);
        },
        style: {
          fontSize: '8px',
        },
      },
      min: -20,
      max: 80,
      tickAmount: 6,
      forceNiceScale: true,
      title: {
        text: 'Knee Angle (deg)',
        style: {
          fontSize: '8px',
        },
        offsetX: 5,
      },
    },
    title: {
      text: `${side}`,
      align: 'center',
      style: {
        fontSize: '14px',
        fontWeight: 'bold',
        fontFamily: 'Montserrat',
      },
    },
    stroke: {
      width: 1,
    },
    colors: colors,
    markers: {
      size: markerSizes,
      colors: markerColors,
      strokeWidth: 1,
      showNullDataPoints: false,
    },
    // annotations: {
    //   xaxis: [
    //     {
    //       x: 0,
    //       borderColor: '#c2c2c2',
    //       strokeDashArray: 5,
    //     },
    //   ],
    //   yaxis: [
    //     {
    //       y: 0,
    //       borderColor: '#c2c2c2',
    //       strokeDashArray: 5,
    //     },
    //   ],
    // },
    legend: {
      show: false,
    },
    tooltip: {
      enabled: false,
    },
  };

  return (
    <div style={{ marginLeft: 'auto', marginRight: 'auto', height: '100%' }}>
      <Chart height='100%' options={options} series={data} type='line' width='100%' />
    </div>
  );
};
